import { render, staticRenderFns } from "./AppSettingsModal.vue?vue&type=template&id=b3bd601c&scoped=true&"
import script from "./AppSettingsModal.vue?vue&type=script&lang=js&"
export * from "./AppSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsModal.vue?vue&type=style&index=0&id=b3bd601c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bd601c",
  null
  
)

export default component.exports